export type ModelType = 'gpt-3.5-turbo' | 'gpt-4' | 'gpt-4o' | 'claude-3-sonnet' | 'claude-3-opus' | 'gemini-pro';

export type ThemeType = 'dark' | 'light' | 'system';

export type Settings = {
  model: {
    defaultModel: ModelType;
    apiKey?: string;
    temperature: number;
    contextWindow: number;
    includeChats: boolean;
    includeKnowledgeBase: boolean;
  };
  ui: {
    theme: ThemeType;
    fontSize: number; // percentage (100 = 100%)
    messageSpacing: number; // 1-5 scale
    codeColorScheme: string;
    autoScroll: boolean;
    showAvatars: boolean;
  };
  notifications: {
    soundEnabled: boolean;
    desktopNotifications: boolean;
    emailNotifications: boolean;
  };
  privacy: {
    saveChatsLocally: boolean;
    sendAnonymousAnalytics: boolean;
    clearChatsOnExit: boolean;
  };
  exportImport: {
    exportFormat: 'json' | 'markdown' | 'txt';
    includeTasks: boolean;
    includeKnowledgeBase: boolean;
  };
  keyboard: {
    sendWithEnter: boolean;
    newLineWithShiftEnter: boolean;
    customShortcuts: Record<string, string>;
  };
};

export const defaultSettings: Settings = {
  model: {
    defaultModel: 'gpt-3.5-turbo',
    temperature: 0.7,
    contextWindow: 4000,
    includeChats: true,
    includeKnowledgeBase: true
  },
  ui: {
    theme: 'dark',
    fontSize: 100,
    messageSpacing: 3,
    codeColorScheme: 'github-dark',
    autoScroll: true,
    showAvatars: true
  },
  notifications: {
    soundEnabled: true,
    desktopNotifications: false,
    emailNotifications: false
  },
  privacy: {
    saveChatsLocally: true,
    sendAnonymousAnalytics: true,
    clearChatsOnExit: false
  },
  exportImport: {
    exportFormat: 'json',
    includeTasks: true,
    includeKnowledgeBase: true
  },
  keyboard: {
    sendWithEnter: true,
    newLineWithShiftEnter: true,
    customShortcuts: {
      'ctrl+shift+n': 'New Chat',
      'ctrl+shift+c': 'Clear Chat',
      'ctrl+shift+s': 'Save Chat'
    }
  }
};
